import AnnouncementsPageView from "./AnnouncementsPageView";

function AnnouncementsPage() {
  return <AnnouncementsPageView />;
}

export default AnnouncementsPage;
